import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=7dca10b9&scoped=true&"
import script from "./DefaultContainer.vue?vue&type=script&lang=js&"
export * from "./DefaultContainer.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DefaultContainer.vue?vue&type=style&index=1&id=7dca10b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca10b9",
  null
  
)

export default component.exports